import { useState } from "react";
import { Bold, Italic, Smile } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const COMMON_EMOJIS = [
  "😀", "😊", "🙏", "👍", "❤️", "🎉", "✅", "🔥",
  "⭐", "📦", "🛒", "💬", "📞", "🚚", "💰", "⚠️",
];

interface Props {
  onInsert: (before: string, after?: string, placeholder?: string) => void;
  onEmoji: (emoji: string) => void;
  disabled?: boolean;
}

export function TemplateFormattingToolbar({ onInsert, onEmoji, disabled }: Props) {
  const [emojiOpen, setEmojiOpen] = useState(false);

  return (
    <div className="flex items-center gap-1 rounded-md border bg-muted/30 p-1">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        disabled={disabled}
        title="Negrito (*texto*)"
        onClick={() => onInsert("*", "*", "texto")}
      >
        <Bold className="h-3.5 w-3.5" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-7 w-7"
        disabled={disabled}
        title="Itálico (_texto_)"
        onClick={() => onInsert("_", "_", "texto")}
      >
        <Italic className="h-3.5 w-3.5" />
      </Button>
      <Popover open={emojiOpen} onOpenChange={setEmojiOpen}>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            disabled={disabled}
            title="Inserir emoji"
          >
            <Smile className="h-3.5 w-3.5" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-2" align="start">
          <div className="grid grid-cols-8 gap-1">
            {COMMON_EMOJIS.map((emoji) => (
              <button
                key={emoji}
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded text-lg hover:bg-muted"
                onClick={() => {
                  onEmoji(emoji);
                  setEmojiOpen(false);
                }}
              >
                {emoji}
              </button>
            ))}
          </div>
        </PopoverContent>
      </Popover>
      <span className="ml-1 text-[10px] text-muted-foreground">*negrito* · _itálico_</span>
    </div>
  );
}
